// extracted by mini-css-extract-plugin
module.exports =  {"toggle-container":"toggle-container-lZfHP","toggle":"toggle-toOWM"};